import React, { useEffect, useState, useRef } from 'react'
import { apiPath1 } from "../services/apiConfig";

export default function RejectedDocs() {
  const token = localStorage.getItem('token');

  const [rejectedDocumentsCnt, setRejectedDocumentsCnt] = useState([]);

  // 
  // Get Data
  //
  async function fetchRejectedDocumentsCnt() {
    //  setLoading(true);
    try {
      // Fetch transaction status data
      const response = await fetch(apiPath1 + "RejectedDocumentsCnt", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
      });
      const result = await response.json();
      if (result.status !== true) {
        throw new Error('Failed to fetch document status data');
      }
      setRejectedDocumentsCnt(result.data);
    } catch (error) {
      console.error("Error fetching Rejected document count:", error);
    }
  }

  useEffect(() => {
    fetchRejectedDocumentsCnt();
  }, []);


  return (
    <>
      <div className="cont__dashboard-pending ml16">
        <h5 className="">Rejected Documents</h5>
        <div className="cont__dashboard-pending-component">
          {
            rejectedDocumentsCnt.map((item, index) => {
              let type = item.Type;
              switch (type) {
                case 'D':
                  type = 'Indent';
                  break;
                case 'I':
                  type = 'Issue';
                  break;
                case 'R':
                  type = 'Return';
                  break;
                case 'T':
                  type = 'Transfer';
                  break;
                case 'X':
                  type = 'Repair';
                  break;
                default:
                  type = item.Type; // Keep original if no match
              }
              return (
                <div className="c12-g-l-2 align-items-center mr8">
                  <div className="box corner-round solid red mt4">{item.TrCount}</div>
                  <p className="sm medium center">{type}</p>
                </div>
              );
            })
          }
        </div>
      </div>
    </>
  );
}

